var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-feats p-5"},[_c('div',{staticClass:"feat m-r-4",on:{"click":_vm.onClickMoreProfile}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_vm._v("프로필 3명 더 받기")]),_c('i',{staticClass:"material-icons i-right"},[_vm._v("chevron_right")])])
}]

export { render, staticRenderFns }